<template>
    <div v-if="visible" class="ai-beta-note mt-2">
        <v-icon x-small class="mr-1 ai-beta-note__icon">mdi-flask-outline</v-icon>
        {{ $t('ai.beta_note') }}
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'AiBetaNote',
    computed: {
        ...mapState(['config']),
        visible(vm = this) {
            return vm.config?.aiBeta !== false
        },
    },
}
</script>

<style scoped>
.ai-beta-note {
    font-size: var(--fs-caption);
    line-height: 1.4;
    color: var(--v-txtMuted-base);
}

.ai-beta-note__icon {
    color: var(--v-txtMuted-base) !important;
}
</style>
